import { Component, OnInit, ViewChild } from '@angular/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { ActivatedRoute } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
@Component({
  selector: 'app-break-duration',
  templateUrl: './break-duration.component.html',
  styleUrls: ['./break-duration.component.scss'],
})
export class BreakDurationComponent implements OnInit {
  button={}
  private handleError: HandleError;
  customDataSource: any;
  FixedPeriod:boolean=false;
  addpopup:string=''
  attendanceFromHour:any
  employee:any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  controllerName: string;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(httpErrorHandler: HttpErrorHandler, public translate:TranslateService,public gt:genericCustomStoreService,
    private validation:CheckValidation,public Objects:ObjectsService,public permissionService :PermissionService,public routee: ActivatedRoute) {
    gt.seturl("Break");
    this.handleError = httpErrorHandler.createHandleError('BreakService');
    gt.submit();
    this.customDataSource = gt.customDataSource; 
    this.button=Objects.button;
  
    this.validateAsync  = this.validateAsync.bind(this);
    this.isFixedPeriod=this.isFixedPeriod.bind(this)

    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );
    const route = this.routee.snapshot.url.join('/'); // This gives the current route path as a string
    console.log(route);
    const permissions = this.permissionService.checkPermissionsForRoute(route);
  
    this.canAdd = permissions[0];
    this.canEdit = permissions[1];
    this.canDelete = permissions[2];
    console.log(this.canAdd);
    console.log(this.canEdit);
    console.log(this.canDelete);
    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }
  
  ngOnInit(): void {
    // Get the current route URL
    const routePath = this.routee.snapshot.url.join('/'); // This returns the current route as a string (e.g., "sales/ProductionLineJobOrder")
    
    // Assuming your URL follows a format like '/controller/action', we can split it to get the controller name.
    this.controllerName = routePath.split('/')[0]; // Assuming the controller is the first part of the URL
    console.log('Current Controller:', this.controllerName);
  }

  validateAsync (params:any) {
    var id = params.data.id??0;
    return this.validation.asyncCheckNameValue(params.value,id,"Break");
  }

   updateRow(options:any) {options.newData = Object.assign(options.oldData, options.newData);}

    validateNumber(e:any) {     
      if(!e.data.isFixedPeriod){
        return e.data?.attendanceFromHour < e.data.leaveToHour  
      }
      else{
        return true
      }   
    }

    isFixedPeriod(newData:any,value:any){
      newData.isFixedPeriod=value
      this.FixedPeriod=value
    }
    onEditingStart(e:any){
      this.FixedPeriod=e.data.isFixedPeriod
      this.addpopup=this.translate.instant('tableinfo.editbutton')
    }
    onInitNewRow(e:any){
      this.FixedPeriod=false
      this.addpopup=this.translate.instant('tableinfo.addbutton')
    }
      onEditorPreparing(e:any) {        
        if (e.parentType === "dataRow"  && e.dataField === "isFixedPeriod") {
            e.editorName = "dxCheckBox"          
            e.editorOptions.value = e.value || false; 
            e.editorOptions.onValueChanged = function (args:any) {
              e.setValue(args.value); 
            }         
        }  
        
        if( e.parentType === "dataRow" && e.dataField === "attendanceFromHour") {
          e.editorOptions.disabled = e.row.data && this.FixedPeriod == true;
      }
        if (e.parentType === "dataRow" && e.dataField === "leaveToHour") {
          
          e.editorOptions.disabled = e.row.data && this.FixedPeriod == true;
      }  
      if (e.parentType === "dataRow" && e.dataField === "numberOfHours" ) {
        e.editorOptions.disabled = e.row.data && this.FixedPeriod == false;
    }  
    if (e.parentType == 'dataRow') {  
      e.editorOptions.onInitialized = function(arg:any) {  
      arg.component.registerKeyHandler("escape", function(arg:any) {  
          e.component.cancelEditData();  
      });  
      }  
  }             
    }
    addrowfun(name:string){
      return this.gt.addrow(name)
    }

  }